/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: SDGameLayoutConstants.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */

namespace BS {
    /**
     * Simple class holding all Constants for Layouting the game.
     * Just fill it up with your own constants
     * e.g. Offset for the Background
     */
    export class SDGameLayoutConstants {
        public static readonly SYMBOL_WIDTH: number = 140;
        public static readonly SYMBOL_HEIGHT: number = 128;
        public static readonly GAME_WIDTH: number = 920;
        public static readonly GAME_HEIGHT: number = 530;

        public static readonly BACKGROUND_X: number = -203;
        public static readonly BACKGROUND_Y: number = -638;
        public static readonly REELOFFSET_X: number = 92;
        public static readonly REELOFFSET_Y: number = 88;
        public static readonly REELOFFSET_GAP: number = 9;
        public static readonly OFFSET_X: number = 50;
        public static readonly OFFSET_Y: number = 10;

        public static readonly LINE_X: number = 59;
        public static readonly LINE_Y: number = 10;
        public static readonly TAG_LEFT_X: number = 59;
        public static readonly TAG_RIGHT_X: number = 837;

        public static readonly LINEY = [290, 180, 390, 140, 90];
        public static readonly TAGLEFTY = [280, 170, 380, 130, 420];
        public static readonly TAGRIGHTY = [280, 170, 380, 130, 420];

        public static readonly WIN_AMOUNT_BOX = {
                x: 0,
                y:494
        };
        
        public static readonly SUN_X: number = 0;
        public static readonly SUN_Y: number = 0;
    }
}
